import React from 'react'
import { FormItemProps, FormItem } from './FormItem'

export interface LabelProps extends FormItemProps {
}

export const Label = (props: LabelProps) => {
  const { preview, label, description } = props
  if (preview) {
    return (
      <>
        <FormItem {...props}>
          <div className="form-value" />
        </FormItem>
        {description && (
        <FormItem label={(
          <span className="form-content-preview" style={{ fontSize: preview ? '10pt' : 'inherits' }}>
            {description}
          </span>
          )}
        />
        )}
      </>
    )
  }
  return (
    <>
      <p>{label}</p>
      {description && <div>{description}</div>}
    </>
  )
}
